import React from "react";
import { useSelector } from "react-redux";
import { clickOnElemnt, rgba } from "../../../../../helpers";
import { classNames } from "../../../../../helpers/classNames";
import { useDispatch } from "react-redux";
import {
  applyTheme,
  selectElement,
  setThemeValue,
} from "../../../../../redux/slice/themeSlice";
import ConfigsTool from "../tools/Configs.Tool";
import { useMutation } from "@tanstack/react-query";
import { siteSettingsUpdate } from "../../../../../services/siteSettingsService";
import Button from "../../../../form/Button";
import themes from "../../../../../db/themes";
import Select from "../../../../form/select/Select";

const Theme = () => {
  const dispatch = useDispatch();
  const { theme, selectedElement, status, colors } = useSelector(
    (state) => state?.themeProvider
  );

  const { mutate: setThemeHandler, isPending } = useMutation({
    mutationFn: async ({ type }) => {
      const advancedSettings = {
        colors: theme?.colors,
        customiseLogo: theme?.customiseLogo,
        menuItem: theme?.menuItem,
        previewPanel: theme?.previewPanel,
        previewPanelHeader: theme?.previewPanelHeader,
        selectedTheme: theme?.selectedTheme,
        sidePanel: theme?.sidePanel,
      };
      const payload = {
        ...theme,
        id: theme?._id,
        advancedSettings,
        ...(type === "reset" && { themeStatus: type }),
      };

      Object.keys(advancedSettings)?.forEach((key) => delete payload[key]);
      const res = await siteSettingsUpdate(payload);
      return { res, type };
    },
    onSuccess: ({ res, type }) => {
      if (res?.status === 200 || res?.status === 201) {
        if (type === "reset") {
          const mod_res = {
            ...(res?.data || {}),
            ...(res?.data?.advancedSettings || {}),
            colors,
          };
          delete mod_res?.advancedSettings;
          dispatch(applyTheme(mod_res));
          dispatch(setThemeValue(mod_res));
        } else {
          const mod_res = {
            ...(res?.data || {}),
            ...(res?.data?.advancedSettings || {}),
          };
          delete mod_res?.advancedSettings;
          dispatch(applyTheme(mod_res));
          dispatch(setThemeValue(mod_res));
        }
      }
    },
    onError: (err) => {
      console.log(err);
    },
  });

  return (
    <div
      className={classNames(
        "w-full max-h-[calc(100%-200px)] h-full scale-[1.003] rounded-lg",
        theme?.previewPanel?.backgroundColor ? "" : "bg-surface-01"
      )}
      {...(theme?.previewPanel?.backgroundColor && {
        style: {
          backgroundColor: rgba(theme?.previewPanel?.backgroundColor),
        },
      })}
    >
      <div className="p-6 h-[calc(100%-64px)] overflow-auto w-full mt-auto flex flex-col">
        <ConfigsTool />
        <div className="w-40 mt-3 editable-element not-changable">
          <Select
            placeholder={"Select theme"}
            selectedValue={theme?.selectedTheme}
            dropdownData={themes}
            onChange={(val, data) => {
              dispatch(setThemeValue({ ...data?.data, selectedTheme: val }));
            }}
            dropdownClass={"editable-element not-changable"}
          />
        </div>
        <div className="flex gap-3 items-center justify-end mt-auto">
          <button onClick={() => setThemeHandler({ type: "reset" })}>
            Reset Theme
          </button>
          <Button
            buttonLabel={"Save Theme"}
            buttonFunction={setThemeHandler}
            variant="secondary"
            {...((status === "loading" || isPending) && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default Theme;
